<!-- =========================================================================================
Khảo sát khách hàng
NTDIEM 08.02.2022
========================================================================================== -->
<template>
  <div v-show="isShowSurvey" class="container flex-column">
    <div v-if="!isShowThankful" class="main-content">
      <div class="content flex-column">
        <!-- Header -->
        <div class="header d-flex">
          <div class="title">
            {{ $t('i18nSurveyCustomer.Title.MainTitle') }}
          </div>

          <div class="close-btn" shortkey-target="Close" @click="close" />
        </div>

        <!-- Content -->
        <div class="wrap-content">
          <div class="detail-content">
            <div class="survey-point flex-column">
              <div class="emoji flex-column">
                <div :class="'icon' + stateSelected + ' emoji-icon'" />
                <!-- <div class="emoji-text">
                {{ surveyState }}
              </div> -->
              </div>
              <div class="list-number d-flex">
                <div
                  v-for="number in numbers"
                  :key="number.num"
                  :class="[
                    { active: number.num <= numberSelected },
                    ' number pointer color' + number.num,
                  ]"
                  @click="selectNumber(number)"
                >
                  {{ number.num }}
                </div>
              </div>
              <div class="flex-row survey-point-des">
                <div>Chưa hài lòng</div>
                <div>Rất hài lòng</div>
              </div>
            </div>
            <div class="description">
              <!-- Lý do đánh giá không hài lòng -->
              <div
                v-show="stateSelected == $ms.enum.CustomerSurveyState.NotGood"
                class="note"
              >
                <div class="note-title">
                  {{ $t('i18nSurveyCustomer.Title.NoteTitle') }}
                </div>
                <div class="group-note-btn d-flex">
                  <div
                    v-for="(reasonType, i) in reasonTypes"
                    :key="i"
                    :class="['note-btn', { 'right-side': i % 2 }]"
                  >
                    <ms-radio
                      v-model="reasonTypeSelected"
                      name="reasonTypeSelect"
                      class=""
                      :label="reasonType.text"
                      :key-value="reasonType.value"
                    />
                  </div>
                </div>
              </div>
              <div v-show="numberSelected" class="des-title">
                {{ detailTitle }}
              </div>
              <div v-show="numberSelected" class="des-detail">
                <ms-textarea
                  ref="inputRef"
                  v-model="userReason"
                  :rows="3"
                  :placeholder="$t('i18nSurveyCustomer.Title.DesInput')"
                  :tabindex="0"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Footer -->
      <div class="flex-row footer">
        <div class="flex" />
        <ms-button
          type="secondary"
          :text="'Để sau'"
          shortkey-target="Close"
          class="mr-2 custom-btn-close"
          :processing="loading"
          :has-border="true"
          @click="close"
        />

        <ms-button
          :disabled="numberSelected == null"
          type="primary"
          :text="'Gửi phản hồi'"
          shortkey-target="Save"
          :processing="loading"
          @click="saveSurvey"
        />
      </div>
    </div>

    <!-- Phần cảm ơn say khi khách hàng đánh giá -->
    <div v-else class="main-content" style="height: 350px; width: 560px">
      <div class="thankful-content flex-column">
        <!-- Header -->
        <div class="header d-flex">
          <div
            class="close-btn"
            shortkey-target="Close"
            @click="setIsShowSurvey(false)"
          />
        </div>
        <div class="thankful-detail-content flex-column">
          <div class="thankful-title">
            Chân thành cảm ơn!
          </div>
          <div class="thankful-sub-title">
            Những chia sẻ của bạn sẽ giúp MISA TaskGo cải tiến sản phẩm ngày
            càng tốt hơn
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { MSEnum } from '@/commons/enumeration';
import {
  ref,
  defineProps,
  defineEmits,
  defineExpose,
  computed,
  getCurrentInstance,
  nextTick,
  onBeforeMount,
  watch,
  onMounted,
  onUnmounted,
  onBeforeUnmount,
  inject,
} from 'vue';
import { I18nInjectionKey } from 'vue-i18n';
import SurveyCustomerAPI from '@/apis/surveycustomer/surveyCustomerAPI.js';
import { useStore } from 'vuex';
import commonFn from '@/commons/commonFunction';
import {
  showError,
  showConfirm,
  showInfo,
  showConfirmDelete,
  showErrorCustom,
  showIncurredDataWarning,
} from '@/commons/globalMessage';
import { ModuleSurveyCustomer } from '@/stores/moduleConst.js';

const { t } = inject(I18nInjectionKey);
const store = useStore();
const context = ref(store.state['context']);

const stateSelected = ref(MSEnum.CustomerSurveyState.Good);
const isShowThankful = ref(false);
const numbers = ref([
  {
    num: 1,
    color: 'color1',
    state: MSEnum.CustomerSurveyState.NotGood,
  },
  {
    num: 2,
    color: 'color2',
    state: MSEnum.CustomerSurveyState.NotGood,
  },
  {
    num: 3,
    color: 'color3',
    state: MSEnum.CustomerSurveyState.NotGood,
  },
  {
    num: 4,
    color: 'color4',
    state: MSEnum.CustomerSurveyState.NotGood,
  },
  {
    num: 5,
    color: 'color5',
    state: MSEnum.CustomerSurveyState.NotGood,
  },
  {
    num: 6,
    color: 'color6',
    state: MSEnum.CustomerSurveyState.NotGood,
  },
  {
    num: 7,
    color: 'color7',
    state: MSEnum.CustomerSurveyState.Good,
  },
  {
    num: 8,
    color: 'color8',
    state: MSEnum.CustomerSurveyState.Good,
  },
  {
    num: 9,
    color: 'color9',
    state: MSEnum.CustomerSurveyState.VeryGood,
  },
  {
    num: 10,
    color: 'color10',
    state: MSEnum.CustomerSurveyState.VeryGood,
  },
]);
const reasonTypes = ref([
  {
    text: t('i18nSurveyCustomer.ReasonType.TransferNotGood'),
    value: 8,
    selected: false,
  },
  {
    text: t('i18nSurveyCustomer.ReasonType.ProductError'),
    value: 2,
    selected: false,
  },
  {
    text: t('i18nSurveyCustomer.ReasonType.ProductNotGood'),
    value: 1,
    selected: false,
  },
  {
    text: t('i18nSurveyCustomer.ReasonType.SecurityNotGood'),
    value: 7,
    selected: false,
  },
  {
    text: t('i18nSurveyCustomer.ReasonType.UseConvenient'),
    value: 5,
    selected: false,
  },
  {
    text: t('i18nSurveyCustomer.ReasonType.SlowProcessingSpeed'),
    value: 6,
    selected: false,
  },
  {
    text: t('i18nSurveyCustomer.ReasonType.SupportServiceNotGood'),
    value: 3,
    selected: false,
  },
  {
    text: t('i18nSurveyCustomer.ReasonType.HighPrice'),
    value: 4,
    selected: false,
  },
]);
const reasonType = ref([]);
const reason = ref([]);
const numberSelected = ref(null);
const surveyInfo = ref({});
const token = ref('');
const applicationURL = ref('');
const loading = ref(false);
const userReason = ref('');
const userReasonErr = ref(false);
const inputRef = ref(null);
const reasonTypeErr = ref(false);
const lastestSurvey = ref({});
const reasonTypeSelected = ref(null);
const detailTitle = computed(() => {
  return numberSelected.value >= 9
    ? t('i18nSurveyCustomer.Title.DesTitle3')
    : numberSelected.value >= 7
      ? t('i18nSurveyCustomer.Title.DesTitle2')
      : t('i18nSurveyCustomer.Title.DesTitle1');
});

/**
 * Cờ hiển thị khảo sát
 */
const isShowSurvey = computed(() => {
  return store.state[ModuleSurveyCustomer].iShowSurvey;
});
watch(
  () => isShowThankful.value,
  (newVal, oldVal) => {
    if (newVal) {
      // Đóng lời cảm ơn sau 5s NTDIEM 14.02.2022
      setTimeout(function () {
        setIsShowSurvey(false);
      }, 5000);
    }
  },
  { immediate: true }
);

watch(
  () => reasonType.value,
  (newVal, oldVal) => {
    if (!newVal.includes(0)) {
      userReasonErr.value = false;
    }
  },
  { immediate: true }
);
//#region  Function

const setIsShowSurvey = (value) => {
  store.commit(`${ModuleSurveyCustomer}/setIsShowSurvey`, value);
  if (!value) {
    isShowThankful.value = false;
    reasonTypeSelected.value = null;
    numberSelected.value = null;
    userReason.value = null;
    stateSelected.value = MSEnum.CustomerSurveyState.Good;
  }
};

onMounted(async () => {
  await getSurveyInfo();
});
/**
 * Sự kiện khi khách hàng chọn điểm cho sản phẩm
 * NTDIEM 08/01/2024
 */
const selectNumber = (number) => {
  const me = this;
  numberSelected.value = number.num;
  stateSelected.value = number.state;
  if (
    number.state == MSEnum.CustomerSurveyState.Good ||
    number.state == MSEnum.CustomerSurveyState.VeryGood
  ) {
    resetReason();
  }
};

/**
 * Reset lại lựa chọn của người dùng
 * NTDIEM 08/01/2024
 */
const resetReason = () => {
  reasonType.value = [];
  reason.value = [];
  reasonTypeSelected.value = null;
};

/**
 * Laays thoong tin NPS
 * 08/01/2024
 */
const getSurveyInfo = async () => {
  const me = this;
  if (context.value.User) {
    let payload = JSON.stringify({
      ApplicationCode: window._appCodeNPS, //Tên mặc định để lấy khảo sát
      UserName: context.value.User.UserName,
      UserId: context.value.User.UserID,
    });
    await SurveyCustomerAPI.getListServeyForUser(payload).then((result) => {
      if (result) {
        if (Array.isArray(result.Data)) {
          surveyInfo.value = result.Data[0];
        } else {
          surveyInfo.value = result.Data;
        }
        token.value = result.Token;
        applicationURL.value = result.ApplicationURL;

        showSurvey(); //Mở form
      }
    })
      .finally(() => {
        commonFn.unmask();
      });
  }
};

/**
 * Hiển thị NPS
 * NTDIEM 08/01/2023
 */
const showSurvey = async () => {
  let paramLastest = {
    KeySearch: context.value.User.MISAID || context.value.User.UserName,
  };
  await SurveyCustomerAPI.getLastestServeyForUser(paramLastest).then(
    (lastestSurveyResult) => {
      if (
        lastestSurveyResult &&
        lastestSurveyResult.Data
      ) {
        lastestSurvey.value = lastestSurveyResult.Data;
      }
    }
  );
  //Điều kiện show khảo sát
  if (!surveyInfo.value || !context.value.User?.FirstTimeLogin) {
    //Nếu không lấy được thông tin survey hoặc không có ngày đăng nhập đầu tiên thì không hiển thị
    setIsShowSurvey(false);
  } else {
    let today = new Date();
    if (
      new Date(today.setDate(today.getDate() - 90)) >=
        new Date(context.value.User?.FirstTimeLogin) && //khảo sát sau 90 ngày kể từ ngày user đăng nhập vào sản phẩm
      !surveyInfo.value.IsFinishServey && //Chưa làm khảo sát
      commonFn.formatDate(surveyInfo.value.CancelTime) !=
        commonFn.formatDate(new Date()) && //Người dùng chưa đóng khảo sát trong ngày
      (surveyInfo.value.CancelCount || 0) < 3 && //Đóng không quá 3
      (!lastestSurvey.value.LastTimeModifiedSurvey ||
        (lastestSurvey.value.LastTimeModifiedSurvey != null &&
          new Date(new Date().setDate(new Date().getDate() - 10)) >=
            new Date(lastestSurvey.value.LastTimeModifiedSurvey))) //Nếu đã làm khảo sát ở app khác thì phải sau 10 ngày mới hiện
    ) {
      setIsShowSurvey(true);
    } else if (
      commonFn.formatDate(surveyInfo.value.CancelTime) ==
        commonFn.formatDate(new Date()) || //Nếu khảo sát đã được đóng trong ngày thi không hiện lại nữa
        surveyInfo.value.CancelCount >= 3 || //Đóng quá 3 lần thì ko hiên lại nữa
        surveyInfo.value.IsFinishServey ///Khách hàng đã khảo sát thì không hiện lại nữa
    ) {
      setIsShowSurvey(false);
    }
  }
};

/**
 * Cập nhật thao tác người dùng khi người dùng đóng khảo sát
 * NTDIEM 08.01.2024
 */
const close = () => {
  const me = this;
  setIsShowSurvey(false);
  let param = JSON.stringify({
    ServeyCustomID: surveyInfo.value.ServeyCustomID,
    ApplicationCode: window._appCodeNPS,
    ApplicationURL: applicationURL.value,
    UserName: context.value.User.UserName,
    FullName: context.value.User.FullName,
    DeviceType: 1, //Loại thiết bị: PC
    UserId: context.value.User.UserID,
    MISAID: context.value.User.MISAID,
    token: token.value,
  });
  SurveyCustomerAPI.UpdateCancelCount(param);
};

/**
 * Lưu ý kiến đánh giá của khách hàng
 * NTDIEM 08.01.2024
 */
const saveSurvey = async () => {
  const me = this;
  if (validateSurvey()) {
    loading.value = true;
    commonFn.mask();
    let dataResult = [
      {
        Question: 'Đánh giá sự hài lòng và sẵn sàng chia sẻ đến mọi người?',
        Answer: numberSelected.value?.toString() || '',
      },
      {
        Question: 'Ý kiến đóng góp thêm (nếu có)?',
        Answer: userReason.value?.toString() || '',
      },
    ];

    if (reasonTypeSelected.value || numberSelected.value <= 6) {
      dataResult.push({
        Question: 'Loại lý do?',
        Answer: reasonTypeSelected.value?.toString() || '0',
      });
    }

    let param = {
      ServeyCustomID: surveyInfo.value.ServeyCustomID,
      FullName: context.value.User.FullName,
      ApplicationURL: applicationURL.value,
      ApplicationCode: window._appCodeNPS,
      UserName: context.value.User.UserName,
      IsFinishServey: true,
      DataResult: JSON.stringify(dataResult),
      CancelCount: surveyInfo.value.CancelCount,
      UserID: context.value.User.UserID,
      DeviceType: 1,
      Token: token.value,
      EditMode: MSEnum.ModelState.Insert,
      PhoneNumber: context.value.User.Mobile,
      Email: context.value.User.Email,
      MISAID: context.value.User.MISAID,
    };

    await SurveyCustomerAPI.SaveServeyResult(param).then((res) => {
      loading.value = false;
      if (res.Success) {
        isShowThankful.value = true;
      }
    });
    commonFn.unmask();
  }
};

/**
 * Validate khảo sát
 * NTDIEM 08.01.2024
 */
const validateSurvey = () => {
  const me = this;
  if (
    numberSelected.value <= 6 &&
    !reasonTypeSelected.value &&
    !userReason.value
  ) {
    showInfo(
      'Bạn cần cần chọn lý do chưa hài lòng trước khi gửi kết quả đánh giá',
      'Khảo sát mức độ hài lòng'
    );
    return false;
  }
  return true;
};
//#endregion
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
.container {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.25);
  z-index: 20;
  position: fixed;
  justify-content: center;
  align-items: center;
}
::v-deep .main-content {
  width: 570px;
  height: auto;
  background-color: #fff;
  box-shadow: 0 4px 16px rgb(0 0 0 / 24%);
  overflow: auto;
  z-index: 21;
  border-radius: 4px;
  position: absolute;
}

.content {
  width: 100%;
  height: 100%;
  // background: url("~@/assets/images/survey/img_nps1.svg") no-repeat;
  padding: auto;
  padding: 24px;
}

.header {
  justify-content: center;
  align-items: center;
}

.title {
  width: 350px;
  height: auto;
  font-size: 16px;
  text-align: center;
  font-weight: bold;
}

.close-btn {
  position: absolute;
  top: 14px;
  right: 16px;
  cursor: pointer;
  background-image: url($ms-image-ic_close-grey-16);
  background-repeat: no-repeat;
  background-position: center;
  height: 20px;
  width: 20px;
}

.emoji {
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;
  margin-bottom: 14px;
}

.emoji-icon {
  width: 42px;
  height: 42px;
  margin-bottom: 12px;
}

.emoji-text {
  font-size: 16px;
  font-weight: 600;
  color: #4e5b6a;
}

.list-number {
  width: 520px;
  justify-content: space-between;
}

.survey-point {
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 24px;
  margin-bottom: 24px;
}

.survey-point-des {
  width: 100%;
  justify-content: space-between;
  margin-top: 10px;
  color: #9e9fab;
}

.number {
  width: 40px;
  height: 40px;
  font-size: 14px;
  font-weight: 600;
  color: #1b1f26;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #dfdfdf;
}

// .number:hover {
//   background: #a6a9be !important;
//   color: #ffff;
// }

.footer {
  padding: 12px 24px;
  border-top: 1px solid #e0e0e0;
  justify-content: flex-end;
}

.des-title {
  margin-bottom: 12px;
  font-weight: $font-weight-medium;
}

.color1.active {
  background-image: linear-gradient(to right, #e92c2c, #e8392b) !important;
  color: #fff !important;
}
.color2.active {
  background-image: linear-gradient(to right, #e73e2b, #e64d29) !important;
  color: #fff !important;
}
.color3.active {
  background-image: linear-gradient(to right, #e55229, #e36028) !important;
  color: #fff !important;
}
.color4.active {
  background-image: linear-gradient(to right, #e36527, #e17326) !important;
  color: #fff !important;
}
.color5.active {
  background-image: linear-gradient(to right, #e07725, #e38920) !important;
  color: #fff !important;
}
.color6.active {
  background-image: linear-gradient(to right, #e48f1c, #e8a216) !important;
  color: #fff !important;
}
.color7.active {
  background-image: linear-gradient(to right, #e9a813, #edba0b) !important;
  color: #fff !important;
}
.color8.active {
  background-image: linear-gradient(to right, #edc009, #eebf0a) !important;
  color: #fff !important;
}
.color9.active {
  background-image: linear-gradient(to right, #bdbf0b, #6abd0c) !important;
  color: #fff !important;
}
.color10.active {
  background-image: linear-gradient(to right, #55bc0c, #1abb0e) !important;
  color: #fff !important;
}

.icon0 {
  background: url('~@/assets/images/survey/ic_emoji1.svg') no-repeat;
}

.icon1 {
  background: url('~@/assets/images/survey/ic_emoji2.svg') no-repeat;
}

.icon2 {
  background: url('~@/assets/images/survey/ic_emoji3.svg') no-repeat;
}

.note-title {
  margin-bottom: 12px;
  font-weight: $font-weight-medium;
}

.group-note-btn {
  flex-wrap: wrap;
  column-count: 2;
  column-gap: 16px;
}

.note-btn {
  height: 38px;
  cursor: pointer;
  width: calc(100% - 216px);
  &.right-side {
    width: 200px;
  }
}

// .note-btn:hover {
//   color: #2979ff !important;
//   background: rgba(41, 121, 255, 0.15) !important;
// }

.note-btn.active {
  color: #2979ff !important;
  background: rgba(41, 121, 255, 0.15) !important;
}

.thankful-content {
  width: 100%;
  height: 100%;
  background: url('~@/assets/images/survey/img_nps2.svg') no-repeat;
  justify-content: center;
  align-items: center;
}

.thankful-detail-content {
  width: 386px;
  justify-content: center;
  align-items: center;
}

.thankful-title {
  font-size: 36px;
  margin-bottom: 12px;
}

.thankful-sub-title {
  font-size: 14px;
  color: $black;
  text-align: center;
}

.text-err-1 {
  font-size: 12px;
  color: #ff6161;
  margin-bottom: 8px;
}

.text-err-2 {
  font-size: 12px;
  color: #ff6161;
  margin-top: 8px;
}

::v-deep .des-detail .ms-textarea .ms-textarea-item::placeholder {
  color: #9e9fab;
}

::v-deep .custom-btn-close .text {
  color: #201e1e;
}

// Misa Review
.misa-review {
  .title-review {
  }
  .content-review {
    .item-review {
      justify-content: space-between;
      align-items: center;
      .item-text {
      }
      .item-star {
        .star {
          width: 10px;
          height: 10px;
          border: 1px solid;
          margin: 0 3px;
          cursor: pointer;
        }
        .star-active {
          background-color: red;
        }
      }
    }
  }
}
</style>